"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const linkedin_icon_svg_1 = tslib_1.__importDefault(require("../assets/img/linkedin-icon.svg"));
const i_lab_icon_svg_1 = tslib_1.__importDefault(require("../assets/img/i_lab-icon.svg"));
const _hoisted_1 = {
    class: "arkyan-container footer-section",
    id: "footer-section"
};
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "logo-container" };
const _hoisted_4 = ["src"];
const _hoisted_5 = { class: "footer-container" };
const _hoisted_6 = { class: "ul-general" };
const _hoisted_7 = { class: "city" };
const _hoisted_8 = { class: "address" };
const _hoisted_9 = { class: "address" };
const _hoisted_10 = { class: "address" };
const _hoisted_11 = {
    key: 0,
    href: "mailto:contact@arkyan.com",
    class: "mailto"
};
const _hoisted_12 = (0, vue_1.createElementVNode)("div", { class: "button-mobile" }, [
    (0, vue_1.createElementVNode)("a", null, [
        (0, vue_1.createElementVNode)("i", { class: "icon-send" })
    ])
], -1);
const _hoisted_13 = [
    _hoisted_12
];
const _hoisted_14 = {
    key: 1,
    href: "mailto:contact@arkyan.com",
    class: "mailto"
};
const _hoisted_15 = { class: "button-container" };
const _hoisted_16 = { class: "button" };
const _hoisted_17 = (0, vue_1.createElementVNode)("div", { class: "slide" }, null, -1);
const _hoisted_18 = { class: "link" };
const _hoisted_19 = (0, vue_1.createElementVNode)("li", { class: "link" }, [
    (0, vue_1.createElementVNode)("a", {
        href: "https://linkedin.com/company/arkyan",
        target: "_blank"
    }, [
        (0, vue_1.createElementVNode)("img", {
            src: linkedin_icon_svg_1.default,
            alt: "linkedin logo"
        })
    ])
], -1);
const _hoisted_20 = (0, vue_1.createElementVNode)("li", null, [
    (0, vue_1.createElementVNode)("img", {
        src: i_lab_icon_svg_1.default,
        alt: "i-lab logo"
    })
], -1);
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("footer", _hoisted_1, [
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            (0, vue_1.createElementVNode)("div", _hoisted_3, [
                (0, vue_1.createElementVNode)("img", {
                    src: $setup.logo(),
                    alt: "Logo"
                }, null, 8, _hoisted_4)
            ]),
            (0, vue_1.createElementVNode)("div", _hoisted_5, [
                (0, vue_1.createElementVNode)("nav", null, [
                    (0, vue_1.createElementVNode)("ul", _hoisted_6, [
                        (0, vue_1.createElementVNode)("ul", null, [
                            (0, vue_1.createElementVNode)("span", _hoisted_7, (0, vue_1.toDisplayString)(_ctx.$t('footer.address.city')), 1),
                            (0, vue_1.createElementVNode)("li", _hoisted_8, (0, vue_1.toDisplayString)(_ctx.$t('footer.address.address1')), 1),
                            (0, vue_1.createElementVNode)("li", _hoisted_9, (0, vue_1.toDisplayString)(_ctx.$t('footer.address.address2')), 1),
                            (0, vue_1.createElementVNode)("li", _hoisted_10, (0, vue_1.toDisplayString)(_ctx.$t('footer.address.address3')), 1),
                            ($setup.mobile)
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", _hoisted_11, _hoisted_13))
                                : ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", _hoisted_14, [
                                    (0, vue_1.createElementVNode)("div", _hoisted_15, [
                                        (0, vue_1.createElementVNode)("div", _hoisted_16, [
                                            _hoisted_17,
                                            (0, vue_1.createElementVNode)("a", null, (0, vue_1.toDisplayString)(_ctx.$t('wrapper.contactCTALabel')), 1)
                                        ])
                                    ])
                                ])),
                            (0, vue_1.createElementVNode)("li", _hoisted_18, (0, vue_1.toDisplayString)(_ctx.$t('footer.legalsLabel')), 1)
                        ]),
                        (0, vue_1.createElementVNode)("ul", null, [
                            (0, vue_1.createElementVNode)("span", null, (0, vue_1.toDisplayString)(_ctx.$t('footer.navigationLabel')), 1),
                            (0, vue_1.createElementVNode)("li", {
                                class: "link",
                                onClick: _cache[0] || (_cache[0] = ($event) => ($setup.SectionSelection($setup.NavigationTabLabel.HOME)))
                            }, (0, vue_1.toDisplayString)(_ctx.$t('navigation.home')), 1),
                            (0, vue_1.createElementVNode)("li", {
                                class: "link",
                                onClick: _cache[1] || (_cache[1] = ($event) => ($setup.SectionSelection($setup.NavigationTabLabel.CLIENTS)))
                            }, (0, vue_1.toDisplayString)(_ctx.$t('navigation.clients')), 1),
                            (0, vue_1.createElementVNode)("li", {
                                class: "link",
                                onClick: _cache[2] || (_cache[2] = ($event) => ($setup.SectionSelection($setup.NavigationTabLabel.PORTFOLIO)))
                            }, (0, vue_1.toDisplayString)(_ctx.$t('navigation.portfolio')), 1)
                        ]),
                        (0, vue_1.createElementVNode)("ul", null, [
                            (0, vue_1.createElementVNode)("span", null, (0, vue_1.toDisplayString)(_ctx.$t('footer.socialMediaLabel')), 1),
                            _hoisted_19
                        ]),
                        (0, vue_1.createElementVNode)("ul", null, [
                            (0, vue_1.createElementVNode)("span", null, (0, vue_1.toDisplayString)(_ctx.$t('footer.awardLabel')), 1),
                            _hoisted_20
                        ])
                    ])
                ])
            ])
        ])
    ]));
}
exports.render = render;
